import { Modal } from 'react-bootstrap'
import { useTranslation } from "react-i18next"

export default function Loading({id='loading', show = false}){
    const { t } = useTranslation()

    return (
        <Modal 
            show={show} 
            id={id} 
            tabIndex={-1} 
            size="sm"
            centered
            role="dialog"
            backdrop="static"
        >
            <Modal.Body className="text-center py-5">
                <div className="spinner-border" role="status" style={{width: 32, height: 32, color: '#D1D5DB'}}>
                    <span className="visually-hidden">{t('global.loading')}...</span>
                </div>
                <p className="mt-3 mb-0" style={{fontSize: 13, color: '#9CA0A8'}}>{t('global.loading')}...</p>
            </Modal.Body>
        </Modal>
      )
}